import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getMyTaskHistory,
  submitCommentApproval
} from '../../api/user-approvals';

export const getMyTaskHistoryAsync = createAsyncThunk(
  'userApprovals/getMyTaskHistory',
  getMyTaskHistory
);

export const submitCommentApprovalAsync = createAsyncThunk(
  'userApprovals/submitCommentApproval',
  submitCommentApproval
);

export interface MyTaskHistory {
  id: number;
  comment: string | null;
  submittedDate: Date;
  isAutoApproval: boolean;
  autoApprovalNote: string | null;
  approvalTypeId: number;
  approvalType: {
    id: number;
    name: string;
  };
  approvalCodeId: number | null;
  approvalCode: {
    id: number;
    name: string;
  } | null;
  projectDocumentWorkflowStepId: number;
  projectDocumentWorkflowStep: {
    id: number;
    dueDate: Date;
    projectDocumentWorkflowId: 22;
    projectDocumentWorkflow: {
      id: number;
      name: string;
      finishedDate: Date | null;
      workflowStatusId: number;
      workflowStatus: {
        id: number;
        name: string;
      };
      currentWorkflowStepId: number;
      currentWorkflowStep: {
        id: number;
        dueDate: string;
        workflowStepId: number;
        workflowStep: {
          id: number;
          name: string;
        };
      };
      projectDocumentRevisionId: number;
      projectDocumentRevision: {
        id: number;
        purposeId: number;
        purpose: {
          id: number;
          abbreviation: string;
          phase: string;
        };
        revisionId: number;
        revision: {
          id: number;
          name: string;
        };
        projectDocumentId: number;
        projectDocument: {
          id: number;
          no: string;
          name: string;
          disciplineId: number;
          discipline: {
            id: number;
            name: string;
            cfihosName: string;
          };
          projectId: number;
          project: {
            id: number;
            projectNo: string;
            name: string;
          };
        };
      };
    };
  };
}

interface UserApprovalState {
  myHistory: {
    data: MyTaskHistory[];
    count: number;
  };
}

const initialState: UserApprovalState = {
  myHistory: {
    data: [],
    count: 0
  }
};

export default createSlice({
  name: 'userApprovals',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMyTaskHistoryAsync.fulfilled, (state, action) => {
      state.myHistory = action.payload;
    });
  }
});
